import { OutlinedInputProps, TextField, TextFieldProps } from "@mui/material";
import { Control, Controller, Path, FieldValues } from "react-hook-form";
import {
  NumberFormatValues,
  PatternFormat,
  PatternFormatProps,
} from "react-number-format";
import RoundInput, { RoundInputProps } from "../RoundInput";

type PatternProps<T extends FieldValues> = RoundInputProps<T> &
  PatternFormatProps<OutlinedInputProps> & {
    control: Control<T>;
    inputName: Path<T>;
    format: string;
  };

export default function PatternInput<T extends FieldValues>({
  inputName,
  control,
  format,
  ...propsText
}: PatternProps<T>) {
  return (
    <>
      <Controller
        control={control}
        name={inputName}
        render={({ field: { onChange, value, ...field } }) => (
          <PatternFormat
            customInput={RoundInput}
            format={format}
            value={value}
            onValueChange={(v: NumberFormatValues) =>
              onChange(v.formattedValue)
            }
            {...propsText}
          />
        )}
      />
    </>
  );
}
